import React, {useContext, useState, useEffect, useRef, useCallback} from "react";
import { isMobile } from "react-device-detect";
import { GlobalContext } from "../../../context/GlobalContext";
import DisplayIcon from "../FailureIcon";
import WorkerSvg from "../../Navbar/InspectionFlags/icons/Worker";
import { CONTENT_API_HOST } from "../../../../src/env";
import {
  WorkerMain,
  Widget,
  Name,
  WidgetInfo,
  NumberOfDays,
  NameDays,
  CodeSmall,
  CountOfEntries,
  SmallName,
  MachineCode,
  MachineName,
  Worker,
  NameBlock,
  ReasonIcon,
  ToolTip,
} from "./MachineStyles";
import { MachineColors } from "./enums";
import CampaignIcon from '@mui/icons-material/Campaign';

function Machine({ machine, background }) {
  const [hasPicture, setHasPicture] = useState(false);
  const [img, setImg] = useState();
  const [repeat, setRepeat] = useState(true);
  const pressTimer = useRef(null);

  const handleTouchStart = (machine, e) => {
    e.preventDefault(); // Prevents unwanted behavior like text selection
    pressTimer.current = setTimeout(() => {
      handleMenu(machine, e)// Show menu on long-press
    }, 1500); // Adjust the delay as needed
  };

  const handleTouchEnd = () => {
    clearTimeout(pressTimer.current); // Clear timeout if the user releases early
  };
  const {
    setMachine,
    setGlobalStatus,
    setGlobalPoints,
    setShow,
    setIsActive,
    setMachineId,
  } = useContext(GlobalContext);

  const handleMenu = (machine, e) => {
    e.preventDefault();
    const subMenu = document.querySelector(".open-sub-menu");

    if (subMenu) {
      subMenu.classList.remove("open-sub-menu");
    }
    setShow(true);
    setGlobalPoints({ x: e.pageX, y: e.pageY });
    setGlobalStatus({ color: machine.EventState, isUrgent: machine.IsUrgent });
    setMachine(machine);
    setMachineId(machine.Id);
    if (isMobile) {
      document.documentElement.style.overflow = "hidden";
      document.body.scroll = "no";
    }
  };

  const MachineMenu = (machine) => {
    setGlobalStatus({
      color: machine.EventState,
      isUrgent: machine.IsUrgent,
    });
    document.documentElement.style.overflow = "hidden";
    document.body.scroll = "no";
    setMachine(machine);
    setMachineId(machine.Id);
    setIsActive((current) => !current);
  }

  useEffect(() => {
    if (machine.Cover !== undefined && machine.Cover !== null) {
      setRepeat(false);
      setHasPicture(true);
      if(machine.Cover.ImageData){
        setImg(`data:${machine.Cover.Content};base64,${machine.Cover.ImageData}`);
      }
      else
      { // URL got not from LogContext because I counldn't use it in JS file
        setImg(CONTENT_API_HOST + "/api/Download/GetMachineLogFile/" + machine.Cover.ContentId)
      }
      //setImg(`data:${machine.Cover.Content};base64,${machine.Cover.ImageData}`);
    } else {
      setHasPicture(false);
      setRepeat(true);
      setImg(null);
    }
  }, [machine]);

  const GetTabColor = (background) => {
    const isMachineUrgent =
      machine.IsUrgent === true || machine.IsUrgent === null;

    const isEventState = machine.EventState;

    const gradientColors = {
      Y: !isMachineUrgent
        ? "linear-gradient(87deg, #F0ECAE 0%, #F0ECAE 28%, rgba(255,253,199,1) 45%, rgba(250,248,202,1) 49%, rgba(255,255,255,0) 65%);"
        : "linear-gradient(87deg, #f2d846 0%, #f2d846 28%, rgba(255,247,126,1) 49%, rgba(236,244,249,0) 60%, rgba(255,255,255,0) 100%)",
      R: !isMachineUrgent
        ? "linear-gradient(87deg, #F0CCDB 0%, #F0CCDB 28%,  rgba(245,215,240,1) 49%, rgba(255,255,255,0) 65%);"
        : "linear-gradient(87deg, #DD8CAE 25%, #DD8CAE 39%, rgba(242,193,234,1) 49%, rgba(236,244,249,0) 60%, rgba(255,255,255,0) 100%);",
      B: !isMachineUrgent
        ? "linear-gradient(87deg,  #9DBEF4 0%, #9DBEF4 28%, rgba(197,229,254,1) 37%, rgba(197,229,254,1) 49%, rgba(255,255,255,0) 65%);"
        : "linear-gradient(87deg, #599eff 25%, #599eff 39%, rgba(225,237,246,1) 49%, rgba(236,244,249,0) 60%, rgba(255,255,255,0) 100%)",
    };

    const colors = {
      Y: !isMachineUrgent ? MachineColors.LightYellow : background,
      R: !isMachineUrgent ? MachineColors.LightRed : background,
      B: !isMachineUrgent ? MachineColors.LightBlue : background,
    };

    if (hasPicture) {
      return gradientColors[isEventState];
    }
    return colors[isEventState];
  };

  function fixDays() {
    if (machine.DaysToFix != null) {
      return `${machine.DaysToFix + 1} dtf`;
    }
    return null;
  }

  let days = fixDays();
  function NameTrim(name) {
    if (
      (window.innerWidth < 560) &
      (machine.MachineReason != null) &
      (machine.Name.length > 15)
    ) {
      return name.substring(0, 15) + "...";
    } else {
      return name;
    }
  }
  const borderStyle = !repeat
    ? {
        borderImage:
          "linear-gradient(to right, #000 50%, transparent 50%) 100% 1",
      }
    : {};

  const isUtcTimeWithinInterval = useCallback((utcTimestamp, intervalMinutes) => {
    if (!utcTimestamp) return false;

    // Convert UTC timestamp to local time
    const timestampUTC = new Date(utcTimestamp);
    const localTimestamp = new Date(timestampUTC.getTime() - timestampUTC.getTimezoneOffset() * 60000);
    const currentTime = new Date();

    // Calculate time difference in milliseconds
    const timeDifferenceInMilliseconds = currentTime.getTime() - localTimestamp.getTime();

    // Convert milliseconds to minutes
    const timeDifferenceInMinutes = timeDifferenceInMilliseconds / (1000 * 60);

    // Check if the time difference is within the specified interval
    return timeDifferenceInMinutes <= intervalMinutes;
  }, []);

  const isRecentRedOrYellowScanAndEnoughTimePassed = useCallback(() => {
    // Return false for blue or green machines
    if (machine.EventState === 'B' || machine.EventState === 'G') return false;

    // Check if alarm is recent (within 5 minutes)
    if (machine.SignalTimestamp && isUtcTimeWithinInterval(machine.SignalTimestamp, 5)) {
      return false;
    }

    // For dark red or dark yellow (urgent) machines: blink until a worker is assigned
    if (machine.IsUrgent && (machine.EventState === 'R' || machine.EventState === 'Y')) {
      return machine.Workers.length === 0;
    }

    // For light red or yellow (non-urgent) machines: blink for 30 minutes upon scan
    if (!machine.IsUrgent && (machine.EventState === 'R' || machine.EventState === 'Y')) {
      if (!machine.LatestScanTimestamp || machine.Workers.length > 0) return false;
      return isUtcTimeWithinInterval(machine.LatestScanTimestamp, 30);
    }

    return false;
  }, [machine.EventState, machine.LatestScanTimestamp, machine.Workers.length, machine.IsUrgent, machine.SignalTimestamp, isUtcTimeWithinInterval]);

  const isAlarmRecent = useCallback(() => {
    if (!machine.SignalTimestamp) return false;
    if (machine.EventState === 'B' || machine.EventState === 'G')
      return false;

    return isUtcTimeWithinInterval(machine.SignalTimestamp, 5);
  }, [machine.SignalTimestamp, machine.EventState, isUtcTimeWithinInterval])

  // Add flash-element class based on machine state:
  // - For dark red/yellow (urgent) machines: blink until a worker is assigned
  // - For light red/yellow (non-urgent) machines: blink for 30 minutes after scan if no workers assigned
  // - For any machine: blink if an alarm was triggered within the last 5 minutes
  const widgetClassName = "card-has-bg";
  const overlayClassName = "card-img-overlay " + (isRecentRedOrYellowScanAndEnoughTimePassed() ? "flash-element" : "");
  return (
    <Widget
      background={GetTabColor(background)}
      className={widgetClassName}
      style={{ backgroundImage: `url(${img})` }}
      // src={"./1.PNG"}
      onTouchStart={(e) => handleTouchStart(machine, e)}
      onTouchEnd={(e) => handleTouchEnd(machine, e)}
      onContextMenu={(e) => {
        handleMenu(machine, e);
      }}
      onDoubleClick={(e) => {
        MachineMenu(machine);
      }}
    >
      <div className={overlayClassName}>
        <MachineName style={borderStyle}>
          <NameBlock>
            <MachineCode>{machine.MachineCode}</MachineCode>
            {machine.Name.length > 25 ? (
              <SmallName>{NameTrim(machine.Name)}</SmallName>
            ) : (
              <Name>{machine.Name}</Name>
            )}
          </NameBlock>
          {isAlarmRecent() && (
              <CampaignIcon style={{
                height: window.innerWidth < 560 ? '35px' : '45px',
                width: window.innerWidth < 560 ? '30px' : '40px',
                color: 'red'
              }}/>
          )}
          {repeat && (
            <ReasonIcon>
                <DisplayIcon
                  value={machine.MachineReason}
                  height={window.innerWidth < 560 ? 35 : 45}
                  width={window.innerWidth < 560 ? 30 : 40}
                  inspector={machine.InspectorsId}
                  useInspectorLogic={false}
                  color={"#363636"}
                />
              {machine.MachineReason != null && (
                <ToolTip>{machine.MachineReason}</ToolTip>
              )}
            </ReasonIcon>
          )}
        </MachineName>
        <WidgetInfo space={repeat ? "space-between" : "flex-start"}>
          <NumberOfDays margin={!repeat ? "20px" : "0px"}>
            <NameDays>{machine.EventDuration}</NameDays>
            {machine.EventDuration !== 1 ? " days" : " day"}
          </NumberOfDays>
          <div>
            <WorkerMain>
              {(() => {
                if (days != null) {
                  if (machine.DaysToFix <= 0)
                    return <CodeSmall color={"red"}>{days}</CodeSmall>;
                  else return <CodeSmall color={"#363636"}>{days}</CodeSmall>;
                }
              })()}

              {machine.Workers.length > 0 && (
                <Worker>
                  <WorkerSvg />
                  {machine?.Workers[machine?.Workers.length - 1].Initials}
                </Worker>
              )}
            </WorkerMain>
          </div>
          {repeat && (
            <CountOfEntries>{machine.EventsCount + "x R"}</CountOfEntries>
          )}
          {!repeat && (
            <CountOfEntries style={{ marginLeft: "10px" }}>
              {machine.EventsCount + "x"}
            </CountOfEntries>
          )}
        </WidgetInfo>
      </div>
    </Widget>
  );
}

export default Machine;
